import React, { useEffect, useState } from 'react';
import { Popover } from 'antd';
import styled from 'styled-components';
import { IsMobile } from 'Utils/UtilityFunctions';

import UpAngleIcon from '../../common/assets/svgIcons/ArrowUpIcon';
import DownAngleIcon from '../../common/assets/svgIcons/DownAngleIcon';
import { greyColor, maxTablet, primaryColor, primaryFont, wMedium, textBlack } from '../../../Utils/utilsStyle';
import { CalendarIcon } from '../assets/svgIcons/CalendarIcon';

type ButtonType = 'text' | 'iconText' | 'iconTextDropdown' | 'customIconTextDropdown' | 'suffix';

const ButtonWrapper = styled.div<{ $active: boolean, $isOpen: boolean, isSuffix?: boolean, variant: ButtonType, width?: string }>`
  height: 30px;
  width: ${({ width }) => width || '112px'};
  padding: 0 8px;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  border-radius: 6px;
  border: 1px solid #DADADA;
  background: #ffffff;
  transition: all 0.2s ease;
  justify-content: ${({ isSuffix, variant }) => (isSuffix && variant === 'suffix') ? 'center' : 'space-between'};
    ${props => props.$isOpen && `
    border-color: ${primaryColor};
  `}
`;

const DropdownIconWrapper = styled.div<{ $active: boolean }>`
  svg {
    width: 10px;
    height: 7px;
  }
`

const ButtonText = styled.span<{ $active: boolean }>`
  display: inline-flex;
  color: ${({ $active }) => ($active ? textBlack : '#00000040')};
  font-family: ${primaryFont};
  font-size: 14px;
  letter-spacing: -0.4px;
  user-select: none;
  @media all and (max-width: ${maxTablet}) {
    font-size: 12px;
  }
`;

const IconWrapper = styled.span<{ $active: boolean; $isMobile: boolean }>`
  display: flex;
  align-items: center;
  svg {
    margin-right: ${({ $isMobile }) => ($isMobile ? '0px' : '5px')};
    g {
      fill: ${greyColor};
    }
    path {
      fill: ${greyColor};
    }
  }
`;

const Separator = styled.div<{ $active: boolean }>`
  width: 1px;
  height: 18px;
  background-color: #DDD;
  margin: 0 7px 0 10px;
`;

interface PopoverButtonProps {
  isActive?: boolean;
  open: boolean;
  setOpen: (val: boolean) => void;
  variant?: ButtonType;
  isSuffix?: boolean;
  text: string;
  icon?: React.ReactNode;
  content: React.ReactNode;
  title?: React.ReactNode;
  width?: string;
  placement?: 'top' | 'bottom' | 'left' | 'right' | 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight' | 'leftTop' | 'leftBottom' | 'rightTop' | 'rightBottom';
}

const Dropdown: React.FC<PopoverButtonProps> = ({
  open,
  setOpen,
  isActive = false,
  variant = 'text',
  isSuffix = false,
  text,
  icon,
  content,
  title,
  width,
  placement,
}) => {
  const isMobile = IsMobile();

  return (
    <Popover
      content={content}
      title={title}
      trigger="click"
      arrow={false}
      open={open}
      onOpenChange={setOpen}
      getPopupContainer={(e: HTMLElement) => e}
      placement={placement}
      className='ant-custom-popover'
    >
      <ButtonWrapper $active={open || isActive} $isOpen={open} isSuffix={isSuffix} variant={variant} width={width}>

        <ButtonText $active={open || isActive}>
          {isSuffix && (
            <IconWrapper $active={open || isActive} $isMobile={isMobile}>{icon}</IconWrapper>
          )}
          {text}
        </ButtonText>

        {variant === 'iconTextDropdown' && (
          <DropdownIconWrapper $active={open || isActive} className='d-flex align-items-center'>
            <Separator $active={open || isActive} />
            {open ? <UpAngleIcon /> : <DownAngleIcon color={greyColor} />}
          </DropdownIconWrapper>
        )}
        {variant === 'customIconTextDropdown' && (
          <DropdownIconWrapper $active={open || isActive} className='d-flex align-items-center'>
            <CalendarIcon />
          </DropdownIconWrapper>
        )}
      </ButtonWrapper>
    </Popover>
  );
};

export default Dropdown;
